export const profileImagePlaceholder = `<svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="86" height="86" rx="27" fill="#ACBBFF"/>
<rect x="20" y="29" width="11" height="11" rx="5.5" fill="white"/>
<rect x="56.5" y="29.5" width="10" height="10" rx="5" fill="white" stroke="white"/>
<path d="M43.5 67.5C31.9 67.5 23.8333 57.8333 22 53H64.5C61.8333 57.8333 55.1 67.5 43.5 67.5Z" fill="white" stroke="white"/>
</svg>
`;
